import { useQueryClient } from "@tanstack/react-query";

import { getQueryKey } from "app/modules/api-client";

export const useCompetitorUpdatesSubscriptionInvalidation = () => {
    const queryClient = useQueryClient();

    return async (activationSetId: string) => {
        await queryClient.invalidateQueries({
            queryKey: getQueryKey({
                tag: "Alerts",
                methodName: "activationCompetitorUpdatesSubscriptionsDetail",
                args: [activationSetId],
            }),
            refetchType: "all",
        });
    };
};
